import { render, staticRenderFns } from "./PolicyItem.vue?vue&type=template&id=736007f8&scoped=true&"
import script from "./PolicyItem.vue?vue&type=script&lang=js&"
export * from "./PolicyItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736007f8",
  null
  
)

export default component.exports